// extracted by mini-css-extract-plugin
module.exports = {"patient-avatar":"styles_patient-avatar__3kknI"};